
<template>
  <div class="main-content">


    <loading :active.sync="isLoading"
             :is-full-page="fullPage"></loading>

    <div class="row">
      <div class="col-md-3">
        <b-input-group append="Find" class="mb-2 mr-sm-2 mb-sm-0">
          <b-input id="inline-form-input-username" placeholder="Search user"></b-input>
        </b-input-group>
      </div>
      <div class="col-md-9">
        <b-button class="btn btn-danger float-right" v-b-modal.add-user>Add new</b-button>
      </div>
    </div>

    <br/>

    <b-table striped hover :items="users" :fields="columns">
      <template v-slot:cell(role)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <span>{{ data.value }}</span>

      </template>

      <template v-slot:cell(username)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <span>{{ data.value }}</span>

      </template>

      <template v-slot:cell(phoneNumber)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <span>{{ data.value }}</span>

      </template>

      <template v-slot:cell(status)="data">
        <div v-if="data.value != null" >
							<span  class="badge badge-success"  v-if="data.value == 'ACTIVE'" >
								Active
							</span>
              <span  class="badge badge-warning"  v-else-if="data.value == 'INACTIVE'" >
								Inactive
							</span>
              <span class="badge badge-danger"  v-else-if="data.value == 'SUSPENDED'" >
								Suspended
							</span>
        </div>
      </template>
      <template v-slot:cell(options)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <b-dropdown text="Action">
          <b-dropdown-item href="#" @click="openEditUserModal(data.item)">Edit</b-dropdown-item>
          <b-dropdown-item href="#" v-if="data.item.role != 'Administrator'" @click="openResetPassword(data.item)">Reset Password</b-dropdown-item>
          <b-dropdown-item href="#" @click="openDeleteUser(data.item)">Delete</b-dropdown-item>
        </b-dropdown>

      </template>

    </b-table>

    <b-modal id="add-user" title="Add User" @cancel="true" @ok="validateBeforeSubmitNewUser"   centered>
      <form action="#" class="form-horizontal"  method="post">
        <input type="hidden" name="_token" />
        <div class="form-body">
          <div class="row" >
            <div class="col-md-12">
              <div class="form-group ">
                <label class="control-label ">Name:</label> <br/>
                <div >
                  <input class="form-control" type="text"  v-model="user.name" />
                </div>
              </div>
              <div class="form-group ">
                <label class="control-label ">Phone number:</label> <br/>
                <div >
                  <input class="form-control" type="text"  v-model="user.phoneNumber" />
                </div>
              </div>
              <div class="form-group ">
                <label class="control-label ">Email / Username:</label> <br/>
                <div >
                  <input class="form-control" type="text"  v-model="user.username" />
                </div>
              </div>

              <div class="form-group ">
                <label class="control-label ">Role:</label> <br/>
                <div >
                  <select class="form-control" v-model="user.role">
                    <option :value="role" v-for="role in roles"> {{ role }}</option>
                  </select>
                </div>
              </div>

            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="edit-user" title="Edit User" @cancel="true" @ok="validateBeforeSubmitEditUser"   centered>
      <form action="#" class="form-horizontal"  method="post">
        <input type="hidden" name="_token" />
        <div class="form-body">
          <div class="row" >
            <div class="col-md-12">
              <div class="form-group ">
                <label class="control-label ">Name:</label> <br/>
                <div >
                  <input class="form-control" type="text"  v-model="user.name" />
                </div>
              </div>
              <div class="form-group ">
                <label class="control-label ">Phone number:</label> <br/>
                <div >
                  <input class="form-control" type="text"  v-model="user.phoneNumber" />
                </div>
              </div>
              <div class="form-group ">
                <label class="control-label ">Email:</label> <br/>
                <div >
                  <input class="form-control" type="text"  v-model="user.username" />
                </div>
              </div>

              <div class="form-group ">
                <label class="control-label ">Role:</label> <br/>
                <div >
                  <select class="form-control" v-model="user.role">
                    <option :value="role.role" v-for="role in roles"> {{ role.role }}</option>
                  </select>
                </div>
              </div>

              <div class="form-group" v-if="user.role == 'Cashier'">
                <label class="control-label ">Tag:</label> <br/>
                <div >
                  <input class="form-control" type="text"  v-model="user.tag" />
                </div>
              </div>

              <div class="form-group ">
                <label class="control-label ">Status:</label> <br/>
                <div >
                  <label for="active">
                    <input type="radio" name="status" id="active" v-model="user.status" value="ACTIVE" /> Active
                  </label>
                  <br/>
                  <label for="suspended">
                    <input type="radio" name="status" id="suspended" v-model="user.status" value="SUSPENDED" /> Suspended
                  </label>
                  <br/>
                  <label for="inactive">
                    <input type="radio" name="status" id="inactive" v-model="user.status" value="INACTIVE" /> Inactive
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

  </div>
</template>
<script>

  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      users:[],
      roles:["Cashier"],
      columns:["name","username","role","status","options"],
      nps_entities:[],
      ranks:[],
      user:{
        id:0,
        name:"",
        username:"",
        phoneNumber:"",
        role:"",
        outletUser: localStorage.getItem("userId")
      },
      isLoading: false,
      fullPage: true,
      filteredRanks:[]
    };
  },
  computed: {

  },
  components: {
    Loading
  },
  mounted (){
    this.getUsersData();
    //this.getRolesData();
  },

  methods: {
    ...mapActions(["addOutletUser","editUser","deleteUser","getUsersByOutlets","getRoles","resetPassword"]),

    getRolesData(){
      let self = this;
      this.getRoles()
        .then((roles) => {
          self.roles = roles;
        })
        .catch(error => {

        })
    },

    openEditUserModal(user){

      this.user = user;




      this.$bvModal.show('edit-user');

    },

    openResetPassword(user){

      this.user = user;

      let self = this;
      this.$bvModal.msgBoxConfirm('Reset password for '+this.user.name +'?')
              .then(value => {

                if(value){
                  self.confirmResetPassword();
                }

              })
              .catch(err => {
                // An error occurred
              })
    },

    openDeleteUser(user){

      this.user = user;

      let self = this;
      this.$bvModal.msgBoxConfirm('Delete '+this.user.name +' from system')
        .then(value => {

          if(value){
            self.confirmDeleteUser();
          }

        })
        .catch(err => {
          // An error occurred
        })
    },
    confirmDeleteUser(){
      this.isLoading = true;

      let self = this;

      this.deleteUser({user_id: this.user.id}).then(() => {
        self.isLoading = false;

        self.$bvToast.toast("User deleted.", {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 5000,
          appendToast: false
        });

        self.getUsersData();

      })
        .catch(error => {

          self.isLoading = false;

          if( typeof error.response.status != "undefined"){
            if(error.response.status == 401){
              location.replace("/login");
            }

          }
          else{

            self.$bvToast.toast(error.message, {
              title: 'Error',
              variant: 'danger',
              autoHideDelay: 5000,
              appendToast: false
            });


          }
        })

    },

    confirmResetPassword(){
      this.isLoading = true;

      let self = this;

      this.resetPassword({userId: this.user.id}).then(() => {
        self.isLoading = false;

        self.$bvToast.toast("User password sent to email / phone number.", {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 5000,
          appendToast: false
        });

        self.getUsersData();

      })
              .catch(error => {

                self.isLoading = false;

                if( typeof error.response.status != "undefined"){
                  if(error.response.status == 401){
                    location.replace("/login");
                  }

                }
                else{

                  self.$bvToast.toast(error.message, {
                    title: 'Error',
                    variant: 'danger',
                    autoHideDelay: 5000,
                    appendToast: false
                  });


                }
              })

    },

    getUsersData(){
      let self = this;
      this.getUsersByOutlets({userId: localStorage.getItem("userId")})
        .then(function (users){
          console.log(users)
          self.users = users;
        })
        .catch(function (error) {

          if( typeof error.response.status != "undefined"){
            if(error.response.status == 401){
              location.replace("/login");
            }

          }
        })
    },

    validateBeforeSubmitEditUser(){
      this.isLoading = true;

      let self = this;

      this.editUser(this.user).then(() => {
        self.isLoading = false;

        self.$bvToast.toast("User saved.", {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 5000,
          appendToast: false
        });

        self.user.name = "";
        self.user.username = "";
        self.user.phoneNumber = "";
        self.user.role = "";
        self.user.tag = "";

        self.getUsersData();

      })
        .catch(error => {

          self.isLoading = false;

          self.$bvToast.toast(error.message, {
            title: 'Error',
            variant: 'danger',
            autoHideDelay: 5000,
            appendToast: false
          });

          /*if( typeof error.response.status != "undefined"){
             if(error.response.status == 401){
               location.replace("/app/sessions/signIn");
             }

          }
          else{




          }*/
        })
    },
    validateBeforeSubmitNewUser(){
      this.isLoading = true;

      let self = this;

      this.addOutletUser(this.user).then(() => {
        self.isLoading = false;

        self.$bvToast.toast("User added.", {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 5000,
          appendToast: false
        });

        self.user.name = "";
        self.user.username = "";
        self.user.phoneNumber = "";
        self.user.role = "";

        self.getUsersData();

      })
        .catch(error => {

          self.isLoading = false;

          self.$bvToast.toast(error.message, {
            title: 'Error',
            variant: 'danger',
            autoHideDelay: 5000,
            appendToast: false
          });

          /*if( typeof error.response.status != "undefined"){
             if(error.response.status == 401){
               location.replace("/app/sessions/signIn");
             }

          }
          else{




          }*/
        })
    }
  }
};
</script>
